export default __webpack_public_path__ + "static/media/hero_1.8234280a.jpg";